import GraphicPackingOverviewSubPage from './graphic-packing-overview-sub-page';
import GraphicPackingStandsSubPage from './graphic-packing-stands-sub-page';
import GraphicPackingChoiseSubPage from './graphic-packing-choise-sub-page';

const GraphicPackingSubPages = {
    OverView: GraphicPackingOverviewSubPage,
    GraphicStands: GraphicPackingStandsSubPage,
    GraphicChoise: GraphicPackingChoiseSubPage
};

export default GraphicPackingSubPages;